<!--
  ~ Copyright (c) Worldline 2020.
  -->

<!DOCTYPE html>

<main role="main">
    <h2 id="pending-title">
        {{ 'pending.title' | translate }}
    </h2>
    <section class="infoBox">
        <p id="pending-description">{{ 'pending.content.text' | translate }}</p>
        <ngx-spinner name="spinner" type = "line-scale"> </ngx-spinner>

        <!--<p class="post-link">-->
        <!--<span ng-click="sign()" class="k-button ic-check">{{ 'wait.content.retry.button' | translate }}</span>-->
        <!--</p>-->
    </section>

<!--
    <p class="back-link" ng-controller="CancelCtrl">
        <span id="cancel-link" ng-click="confirmCancel()">{{ 'evidences.cancel' | translate }}</span>
        &lt;!&ndash;<span ng-if="errorMsg">{{ errorMsg | translate }}</span>&ndash;&gt;
    </p>
-->

</main>
